<div class="container mt-4">
  <ngb-alert [type]="'info'" [dismissible]="false">
    If you are an implanter (eg Vet, Breeder, Rescue), please
    <a
      class="fw-bold"
      [href]="adminLoginUrl"
      target="_blank"
      rel="nofollow"
      >click here</a
    >
    to log into the admin site.
  </ngb-alert>

  <ngb-alert
    *ngIf="alert"
    [type]="alert.type"
    (closed)="closeAlert()"
    class="sticky-top"
    style="top: 10px"
    >{{ alert.message }}</ngb-alert
  >

  <div class="row mb-3">
    <div class="col-12">
      <h1 class="text-center">Register</h1>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4 mb-3">
      <form #registerForm="ngForm" (ngSubmit)="signUp()" novalidate>
        <form
          #emailSubform="ngForm"
          [appMatchingFields]="['email', 'emailConfirm']"
          novalidate
        >
          <div class="mb-0">
            <div class="mb-0">
              <label class="form-label mb-0" for="email"> Email address </label>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  [class.is-invalid]="email.touched && !email.valid"
                  [emailDot]="true"
                  id="email"
                  name="email"
                  [(ngModel)]="model.emailAddress"
                  placeholder="Email address"
                  type="email"
                  matInput
                  #email="ngModel"
                  required
                />
                <!--This next div is needed to make the input high enough-->
                <div class="dummy-div" matSuffix></div>
                <mat-error
                  *ngIf="
                    (email.errors && email.errors.required) ||
                    (email.errors && email.errors.email) ||
                    (email.errors && email.errors.emailMustEndWith)
                  "
                >
                  {{
                    email.errors && email.errors.required
                      ? errorStrings.required
                      : email.errors && email.errors.email
                      ? errorStrings.emailInvalid
                      : errorStrings.emailMustEndWith
                  }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>

        <form
          #passwordSubform="ngForm"
          [appMatchingFields]="['password', 'passwordConfirm']"
          novalidate
        >
          <div class="mb-0">
            <div class="mb-0">
              <label class="form-label mb-0" for="password"> Password </label>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  #password="ngModel"
                  [type]="hidePassword ? 'password' : 'text'"
                  [class.is-invalid]="password.touched && !password.valid"
                  id="password"
                  minlength="8"
                  name="password"
                  [(ngModel)]="model.password"
                  placeholder="Password"
                  required
                />
                <button
                  type="button"
                  mat-icon-button
                  matSuffix
                  (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hidePassword"
                >
                  <mat-icon>{{
                    hidePassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    (password.errors && password.errors.minlength) ||
                    (password.errors && password.errors.required)
                  "
                >
                  {{
                    password.errors && password.errors.minlength
                      ? errorStrings.passwordTooShort
                      : errorStrings.required
                  }}
                </mat-error>
              </mat-form-field>
              <app-password-strength
                [passwordToCheck]="model.password"
              ></app-password-strength>
            </div>
          </div>

          <div class="mb-0">
            <div class="mb-0">
              <label class="form-label mb-0" for="passwordConfirm">
                Confirm password
              </label>
            </div>
            <div>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  #passwordConfirm="ngModel"
                  [type]="hideConfirmPassword ? 'password' : 'text'"
                  [class.is-invalid]="
                    passwordConfirm.touched && !passwordConfirm.valid
                  "
                  id="passwordConfirm"
                  minlength="8"
                  name="passwordConfirm"
                  [(ngModel)]="passwordConfirmValue"
                  placeholder="Confirm password"
                  required
                />
                <button
                  mat-icon-button
                  type="button"
                  matSuffix
                  (click)="hideConfirmPassword = !hideConfirmPassword"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideConfirmPassword"
                >
                  <mat-icon>{{
                    hideConfirmPassword ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
                <mat-error
                  *ngIf="
                    (passwordConfirm.errors &&
                      passwordConfirm.errors.required) ||
                    (passwordConfirm.errors &&
                      passwordConfirm.errors.minlength) ||
                    (passwordConfirm.errors &&
                      passwordConfirm.errors.matchingFields)
                  "
                >
                  {{
                    passwordConfirm.errors && passwordConfirm.errors.required
                      ? errorStrings.required
                      : passwordConfirm.errors &&
                        passwordConfirm.errors.minlength
                      ? errorStrings.passwordTooShort
                      : errorStrings.passwordMismatch
                  }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="mb-2 text-center">
            <div class="justify-text">
              By creating and account you agree to identibase’s
              <a routerLink="/terms-and-conditions" target="_blank">
                terms & conditions
              </a>
              and
              <a routerLink="/privacy" target="_blank"> privacy policy. </a>
            </div>
          </div>

          <div ngbAccordion [closeOthers]="true">
            <div ngbAccordionItem id="alert" title="Select communication preferences">
              <div ngbAccordionHeader>
                <div class="card border-0">
                  <button class="toggle-button card-header" ngbAccordionButton>
                    you must choose your marketing preferences here to complete registration
                  </button>
                </div>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <span [formGroup]="communicationForm">
                      <div class="mb-3">
                        <label
                          class="form-check-label d-flex justify-content-center align-items-center"
                        >
                          <input
                            class="me-3 communication-checkbox internal-communication-checkbox"
                            id="subToAllInternalCommunication"
                            name="subToAllInternalCommunication"
                            formControlName="subscribeToAllInternalCommunication"
                            type="checkbox"
                          />
                          <div class="justify-text">
                            We would love to keep you up to date with all our latest
                            news, offers, useful pet tips and pet related content.
                            Tick the box if you
                            <strong>do not want</strong> to be contacted.
                          </div>
                        </label>
                      </div>
                      <div class="justify-text">
                        <p>
                          We have partnered with carefully selected 3rd parties so
                          that we can send you exclusive offers and promotions on
                          pet food, pet accessories, pet insurance and other pet
                          related services by email and SMS.
                        </p>
                      </div>
                      <div formGroupName="thirdPartySubscribeOptionSelectGroup">
                        <div class="mb-0">
                          <label class="form-check-label d-flex align-items-center">
                            <input
                              class="me-3 communication-checkbox"
                              id="subscribeToAllThirdParty"
                              name="subscribeToAllThirdParty"
                              formControlName="subscribeToAllThirdParty"
                              (change)="onSubscribeOptionChanged($event)"
                              type="checkbox"
                            />
                            <span
                              >Tick here if you <strong>do want</strong> to receive
                              this or</span
                            >
                          </label>
                        </div>
                        <div class="mb-0">
                          <label class="form-check-label d-flex align-items-center">
                            <input
                              class="me-3 communication-checkbox"
                              id="unsubscribeFromAllThirdParty"
                              name="unsubscribeFromAllThirdParty"
                              formControlName="unsubscribeFromAllThirdParty"
                              (change)="onSubscribeOptionChanged($event)"
                              type="checkbox"
                            />
                            <span
                              >Tick here if you <strong>do not want</strong> to
                              receive this.</span
                            >
                          </label>
                        </div>
                        <span
                          *ngIf="
                            thirdPartyCheckboxStateChanged &&
                            communicationForm.controls[
                              'thirdPartySubscribeOptionSelectGroup'
                            ].errors
                          "
                          class="invalid-checkboxes"
                        >
                          One of the two options is required
                        </span>
                        <div class="justify-text mt-2">
                          <p>
                            We do not pass on your personal data to any 3rd parties.
                          </p>
                        </div>
                        <div class="mb-0 mt-3">
                          <label class="justify-text mb-0">
                            You can change your communication options or unsubscribe
                            at any time by updating your account preferences in your
                            account or by contacting us.
                          </label>
                        </div>
                      </div>
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div
        class="col-12 p-0 m-0"
        (mouseenter) ="onRegisterClick()"
        >
          <button
            type="submit"
            class="btn btn-success text-white btn-lg w-100 mt-3"
            [disabled]="
              !registerForm.valid ||
              !emailSubform.valid ||
              !passwordSubform.valid ||
              loading ||
              communicationForm.invalid
            "
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-3"
            ></fa-icon>
            {{ loading ? "Register..." : "Register" }}
          </button>
          <span *ngIf="validationErrorMessage" class="validation-error-text">{{validationErrorMessage}}</span>
        </div>
      </form>
    </div>
  </div>
</div>
